import { Icon, type INamedIconProps } from '@public/components/Icon/Icon';

export const EnteredIcon = ({ ...props }: INamedIconProps) => (
  <Icon height="12" iconName="Entered" viewBox="0 0 22 18" y="25%" {...props} />
);
